import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import { CommonModule, NgOptimizedImage } from "@angular/common";

@Component({
  selector: 'ind-no-search-result',
  templateUrl: 'ind-no-search-result.html',
  styleUrls: ['ind-no-search-result.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
})
export class IndNoSearchResultComponent {
  @Input() text: string = '';
  @Input() src: string = 'assets/imgs/search-illustration.svg'
  @Input() hideImage: boolean = false;

  constructor(
  ) {}
}
